













import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Field } from "vant";
import dataShare from "@/views/mall/dataShare";
import { times } from "lodash";
@Component({
  name: "remarks",
  components: {
    [Field.name]: Field,
  },
})
export default class Remarks extends Vue {
  //data
  demandContent: string = "";
  dataShare = dataShare;

  //created
  created() {
    this.demandContent = dataShare.demandContent;
  }

  //methods
  back() {
    history.back();
  }
  save() {
    this.dataShare.demandContent = this.demandContent;
    this.back();
  }
}
